import { PIX_KEY_TYPE_LABELS } from "../../../Utils/detectPixKeyType";

const maskDocument = (doc) => {
  const digits = String(doc || "").replace(/\D/g, "");
  if (digits.length >= 14) {
    return `**.***.**${digits.slice(8, 12)}/${digits.slice(12, 14)}-**`;
  }
  if (digits.length >= 11) {
    return `**.***.***${digits.slice(9, 11)}-**`;
  }
  return doc ? "**.***.***-**" : "";
};

const generateTransactionId = (pixId) => {
  const base = String(pixId || "pix").replace(/\W/g, "").slice(0, 8);
  const ts = Date.now().toString(36);
  return `E${base}${ts}`.toUpperCase().slice(0, 32);
};

const generateAuthId = () =>
  Array.from({ length: 40 }, () => Math.floor(Math.random() * 16).toString(16)).join("");

const hasDetailSections = (data) =>
  Array.isArray(data?.details) && data.details.some((section) => section?.items?.length);

/**
 * Builds the receipt shape expected by PixTransferFinalStep / ReceiptDetails.
 * Merges API confirm response with form + initiate-payment context.
 */
export const buildPixTransferReceipt = ({
  initiateState = {},
  amount,
  destinationDraft,
  sourceAccountLabel,
  apiData,
}) => {
  const resolvedAmount = apiData?.amount ?? amount ?? initiateState?.amount;
  const date = apiData?.date ?? initiateState?.date ?? new Date().toISOString();
  const receiver = apiData?.receiver ?? initiateState?.receiver ?? {};
  const pixId = apiData?.pix_id ?? initiateState?.pix_id;

  if (hasDetailSections(apiData)) {
    return {
      ...initiateState,
      ...apiData,
      amount: resolvedAmount,
      date,
      receiver,
      pix_id: pixId,
    };
  }

  const destKeyType = destinationDraft?.pixKeyType
    ? PIX_KEY_TYPE_LABELS[destinationDraft.pixKeyType] || destinationDraft.pixKeyType
    : destinationDraft?.mode === "qrcode"
      ? "Pix copia e cola"
      : null;

  const payer = apiData?.payer ?? initiateState?.payer ?? {};
  const authId = apiData?.authId ?? generateAuthId();
  const endToEndId = apiData?.endToEndId ?? generateTransactionId(pixId);

  const details = [
    {
      value: "Origem",
      items: [
        payer.name && { title: "Nome", value: payer.name },
        payer.document && { title: "Documento", value: maskDocument(payer.document) },
        sourceAccountLabel && { title: "Conta", value: sourceAccountLabel },
      ].filter(Boolean),
    },
    {
      value: "Destino",
      items: [
        destKeyType && { title: "Tipo", value: `Chave Pix (${destKeyType})` },
        receiver.bank_name && { title: "Banco", value: receiver.bank_name },
        receiver.agency && { title: "Agência", value: receiver.agency },
        receiver.name && { title: "Recebedor", value: receiver.name },
        receiver.document && {
          title: "Documento do recebedor",
          value: maskDocument(receiver.document),
        },
      ].filter(Boolean),
    },
    {
      value: "Identificação",
      items: [
        { title: "ID da transação", value: endToEndId },
        { title: "Autenticação", value: authId },
      ],
    },
  ];

  return {
    ...initiateState,
    ...apiData,
    amount: resolvedAmount,
    date,
    type: apiData?.type ?? initiateState?.type ?? "",
    receiver,
    pix_id: pixId,
    details,
  };
};
